var _path, _path2, _line, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 43.5561H14.091L31.335 55.4784C31.7873 55.79 32.3125 55.9689 32.8548 55.9963C33.3972 56.0237 33.9366 55.8985 34.416 55.634C34.8948 55.3681 35.2951 54.9725 35.574 54.4892C35.853 54.0059 36.0002 53.4531 36 52.8899V3.10966C35.9997 2.54688 35.8523 1.99472 35.5733 1.51198C35.2944 1.02924 34.8944 0.634013 34.416 0.36838C33.9376 0.102748 33.3987 -0.0233367 32.8566 0.00355452C32.3146 0.0304458 31.7898 0.209306 31.338 0.521085L14.091 12.4434H6C2.691 12.4434 0 15.2343 0 18.666V37.3336C0 40.7653 2.691 43.5561 6 43.5561ZM6 18.666H15C15.099 18.666 15.183 18.6162 15.279 18.6069C15.677 18.5643 16.0632 18.4417 16.416 18.246C16.494 18.2024 16.587 18.1931 16.662 18.1433L30 8.9215V47.078L16.665 37.8562C16.59 37.8002 16.497 37.794 16.419 37.7536C16.065 37.5528 15.6749 37.4299 15.273 37.3927C15.177 37.3833 15.096 37.3336 15 37.3336H6V18.666Z",
    fill: "#3E79C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45V11",
    stroke: "#3E79C4",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 18,
    y2: -1.5,
    transform: "matrix(0 -1 -1 0 42 37)",
    stroke: "#3E79C4",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49V7",
    stroke: "#3E79C4",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.7031284783649cf372598421f8156b9b.svg";
export { ForwardRef as ReactComponent };